export default __webpack_public_path__ + "static/media/pin.2c22c163.png";